// 基础信息
import { i18n } from '@/common/utils/i18n'
import i18nVue from '@/i18n/locale'
import { get } from 'lodash-es'
import ShopType from '@/pages/shopDetail/config/ShopType'
// 缺失 合作方式
// 缺失 门店品类

export default state => {
  const baseDetail = get(state, 'currentShopBaseDetail', {})
  const currentDish = get(state, 'currentDish', {})

  const currentBizoppDetail = baseDetail
  const appOperatorInfo = baseDetail.appOperatorInfo || []
  const staffInfo = baseDetail.staffInfo || []

  const formatContactInfo = (info, contactTime, index) => {
    return [
      info.name && `${i18nVue.t('FoodB_email_FvUP_tJQT' /** 姓名 */)}: ${info.name}`,
      info.phone && `${i18nVue.t('FoodB_email_Cebi_VpDl' /** 电话 */)}: ${info.phone}`,
      info.mail && `${i18nVue.t('FoodB_email_CBNM_cSdr' /** 邮箱 */)}: ${info.mail}`,
      info.contactMode &&
        info.contactMode.length > 0 &&
        `${i18nVue.t('FoodB_email_mlcn_NvDS' /** 倾向联系方式 */)}: ${info.contactMode.join(',')}`,
      contactTime?.startTime &&
        contactTime?.endTime &&
        `${i18nVue.t('FoodB_email_qCka_NBMf' /** 倾向联系时间 */)}: ${contactTime.startTime}-${
          contactTime.endTime
        }`,
    ]
      .filter(Boolean)
      .join('\n')
  }

  const formatMultipleContacts = (infos, baseTitle) =>
    infos.map((info, index) => ({
      title: `${baseTitle}${index > 0 ? ` ${index + 1}` : ''}`,
      label: formatContactInfo(info, info.contactTime?.[0], index),
    }))

  return [
    {
      title: i18n.gettext('门店名称'),
      label: baseDetail.name,
    },
    {
      title: i18n.gettext('门店ID'),
      label: baseDetail.shopId,
      copy: true,
    },
    {
      title: i18n.gettext('城市'),
      label: baseDetail.cityName,
    },
    {
      title: i18n.gettext('门店地址'),
      label: baseDetail.addr,
    },
    {
      title: i18n.gettext('邮编'),
      label: baseDetail.postCode,
    },
    {
      title: i18n.gettext('门店POI'),
      label: i18n.gettext('查看'),
      isLink: true,
      isMap: true,
    },
    {
      title: i18n.gettext('商圈'),
      label: baseDetail.areaName,
    },
    {
      title: i18n.gettext('门店类型'),
      label: ShopType.val2text(baseDetail.type),
    },
    {
      title: i18n.gettext('门店电话'),
      label: baseDetail.phone,
      isPhone: true,
    },
    // {
    //   title: i18n.gettext('合作方式'),
    //   label: ''
    // },
    {
      title: i18n.gettext('门店品类'),
      label:
        baseDetail.category &&
        baseDetail.category
          .map(value => {
            return currentDish[value]
          })
          .join(','),
    },
    {
      title: i18nVue.t('FoodB_email_Zgsh_mNSy' /** KP */),
      label: [
        baseDetail.kpName &&
          `${i18nVue.t('FoodB_email_FvUP_tJQT' /** 姓名 */)}: ${baseDetail.kpName}`,
        baseDetail.kpPhone &&
          `${i18nVue.t('FoodB_email_Cebi_VpDl' /** 电话 */)}: ${baseDetail.kpPhone}`,
        baseDetail.kpEmail &&
          `${i18nVue.t('FoodB_email_CBNM_cSdr' /** 邮箱 */)}: ${baseDetail.kpEmail}`,
        currentBizoppDetail.kpContactTime &&
          `${i18nVue.t('FoodB_email_qCka_NBMf' /** 倾向联系时间 */)}: ${
            currentBizoppDetail.kpContactTime.startTime
          }-${currentBizoppDetail.kpContactTime.endTime}`,
        currentBizoppDetail.kpContactMode &&
          `${i18nVue.t('FoodB_email_mlcn_NvDS' /** 倾向联系方式 */)}: ${
            currentBizoppDetail.kpContactMode
          }`,
      ]
        .filter(Boolean)
        .join('\n'),
    },
    ...formatMultipleContacts(appOperatorInfo, i18nVue.t('FoodB_email_KYaO_tHVJ' /** APP操作员 */)),
    ...formatMultipleContacts(staffInfo, i18nVue.t('FoodB_email_Bwgs_muyN' /** 店员 */)),
    {
      title: i18n.gettext('销售姓名'),
      label: baseDetail.bdName,
    },
    {
      title: i18n.gettext('销售电话'),
      label: baseDetail.bdPhone,
      isPhone: true,
    },
    {
      title: i18n.gettext('关联签约主体名称'),
      label: baseDetail.contractorName,
    },
    {
      title: i18n.gettext('关联品牌名称'),
      label: baseDetail.brandName,
    },
    {
      title: i18n.gettext('门店logo'),
      isLink: true,
      arrow: true,
      pics: baseDetail.logoImg,
    },
    {
      title: i18n.gettext('门脸照片'),
      isLink: true,
      arrow: true,
      pics: baseDetail.shopPics && baseDetail.shopPics.frontPhoto,
    },
    {
      title: i18n.gettext('店内环境'),
      isLink: true,
      arrow: true,
      pics: baseDetail.shopPics && baseDetail.shopPics.environmentalPhoto,
    },
  ]
}
